"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _localization = require("@lt/localization");
var _SearcherFilters = _interopRequireDefault(require("../SearcherAbstractFilters/SearcherFilters"));
var SearcherFormFilters = function SearcherFormFilters(_ref) {
  var className = _ref.className,
    addServicesFilters = _ref.addServicesFilters,
    activeFilters = _ref.activeFilters,
    onSubmitFilters = _ref.onSubmitFilters,
    isMobile = _ref.isMobile,
    isHotelOnly = _ref.isHotelOnly,
    isOpenFiltersList = _ref.isOpenFiltersList,
    clearSearcherFilters = _ref.clearSearcherFilters;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, !(0, _isEmpty2["default"])(addServicesFilters) && /*#__PURE__*/_react["default"].createElement(_SearcherFilters["default"], {
    key: String(Object.values(activeFilters || {})),
    activeFilters: activeFilters,
    options: addServicesFilters,
    onSubmit: onSubmitFilters,
    isMobile: isMobile,
    isHotelOnly: isHotelOnly,
    isOpenFiltersList: isOpenFiltersList,
    clearSearcherFilters: clearSearcherFilters
  }));
};
var _default = exports["default"] = SearcherFormFilters;